import React from 'react'
import {Route, Switch} from 'react-router-dom'

import Landing from 'modules/Landing'
import Login from 'modules/Auth/Login'
import Logout from 'modules/Auth/Logout'
import Register from 'modules/Auth/Register'
import UserProfile from 'modules/UserProfile'
import BillingInfo from 'modules/UserProfile/BillingInfo'
import ProductDetailPage from 'modules/ProductDetailPage'

import Components from 'components/Components'

const Routes = () => (
  <Switch>
    <Route exact path='/' component={Landing}/>
    <Route exact path='/login' component={Login}/>
    <Route exact path='/logout' component={Logout}/>
    <Route exact path='/register' component={Register}/>
    <Route exact path='/profile' component={UserProfile}/>
    <Route exact path='/profile/billing-info' component={BillingInfo}/>

    <Route exact path='/product/ean/:ean' component={ProductDetailPage}/>
    <Route exact path='/product/uuid/:targetId/:externalId' component={ProductDetailPage}/>

    <Route exact path='/components' component={Components}/>
  </Switch>
)

export default Routes
